import { MAP_TYPES } from '@deck.gl/carto';

const CALEQUITYINDEX_SOURCE_ID = 'calEquityIndexSource';

const source = {
  id: CALEQUITYINDEX_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'cartointegration',
  data: 'encoded-yen-457719-m0.equity_index.silver_eqi_gbd_geom_tileset',
};

export default source;
